document.addEventListener('DOMContentLoaded', function () {
  // Show/Hide header tabs
  document.querySelectorAll('.tab-section').forEach(section => {
  const tabs = section.querySelectorAll('.tab');
  const tabContents = section.querySelectorAll('.tab-content');  
  const tabViewAll = section.querySelectorAll('.view-all-link');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all tab contents
        tabs.forEach(t => t.classList.remove('active-tab'));
        tabContents.forEach(content => content.classList.remove('active-tab-content'));
        tabViewAll.forEach(v => v.classList.remove('active-view-all-link'));
        
        // Add active class to the selected tab content
        const dataId = tab.getAttribute('data-id');
        tab.classList.add('active-tab');
        section.querySelector(`.tab[data-id="${dataId}"]`).classList.add('active-tab');
        section.querySelector(`.tab-content[data-id="${dataId}"]`).classList.add('active-tab-content');
        section.querySelector(`.view-all-link[data-id="${dataId}"]`).classList.add('active-view-all-link');
      });
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tab').forEach(tab => {
    tab.addEventListener('click', function () {
      if (window.innerWidth <= 749) {
        tab.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      }
    });
  });
});

